import React from "react"
import PropTypes from "prop-types"

class SettingsLongTextInput extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
      return(
        <div
          style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: 2, paddingTop: 7}}>
            <p className="label_standard">{this.props.label}</p>
            <textarea
              onChange={(event) => this.props.onChange(event.target.value, this.props.attribute)}
              value={this.props.value}
              rows={10}
              className="input_standard"
              placeholder={this.props.placeholder} />
        </div>
      )
  }
}

export default SettingsLongTextInput;

// <SettingsLongTextInput
//   label={}
//   value={}
//   inputError={}
//   onChange={}
//   placeholder={}
// />
